/**
 * Lightweight US-phone helpers for the MFA enrollment flow. Kept separate
 * from `<PhoneInput />` so that file only exports a component and Vite's
 * fast-refresh stays happy.
 *
 * Atlas only onboards US-based employees today, so an inline regex + a
 * "+1" prefix is sufficient. Swap to `libphonenumber-js` if/when we add
 * international users.
 */

export function normalizeUsPhone(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  if (raw.trim().startsWith('+')) return `+${digits}`;
  return raw.trim();
}

export function validateE164(value: string): boolean {
  // E.164 = +<country><subscriber>, total 8–15 digits. Twilio rejects
  // anything outside this range with a clear error, so this lighter
  // client check is just for UX (disable the Send button).
  return /^\+[1-9]\d{7,14}$/.test(value);
}
